import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import PoModal from "../../../components/Modal/PoModal";
import ApModal from "../../../components/Modal/ApModal";
import ItemTable from "../../../components/Content/ItemTable";
import FormAction from "../../../components/Actions/FormAction";
import Summary from "../../../components/Footer/Summary";

// Model
import { recMasterModel } from "../../../../model/Purchase/RecMasterModel";
import { recDetailModel } from "../../../../model/Purchase/RecDetailModel";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getByRecId,
  getDocType,
  getTransType,
  getViewPoH,
  getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxRecNo,
  getLineByDocId,
  updateStatusByNo,
  updateQty,
  deleteData,
  randomDelay,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import Swal from "sweetalert2";

function Form({ callInitialize, mode, name, maxRecNo, getReport, initData }) {
  const [formMasterList, setFormMasterList] = useState(recMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [poDataList, setPoDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);

  // เพิ่ม state สำหรับเอกสารอ้างอิง
  const [docRefType, setDocRefType] = useState("1"); // Default: จ่ายตามใบสั่งซื้อ

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะใบรับสินค้า
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // การแสดงสถานะการจ่ายของใบรับสินค้า
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");

  // ตัวแปรสำหรับเก็บจำนวนเดิมเอาไว้
  const [formDetailOldList, setFormDetailOldList] = useState([]);

  // Modal สำหรับ Confirm Dialog ของรับสินค้า PO
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // ตัวแปรเก็บ PO
  const [poDList, setPoDList] = useState([]);
  const [docStatusPo, setDocStatusPo] = useState(null);
  const [docStatusReceivePo, setDocStatusReceivePo] = useState(null);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // เก็บรายการ dtId ที่จะลบเมื่อกดบันทึก
  const [itemsToDelete, setItemsToDelete] = useState([]);

  // ✅ เพิ่ม useEffect เพื่อตรวจสอบ initData
  useEffect(() => {
    console.debug("📌 Form useEffect - initData:", initData);
    initialize();
  }, [initData?.timestamp]); // ใช้ timestamp เป็น dependency

  useEffect(() => {
    if (mode === "C") {
      console.debug("📌 Form ในโหมดสร้างใหม่ - เรียก initialize");
      initialize();
    }
  }, [mode]);

  const initialize = async () => {
    try {
      setIsLoading(true);
      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const poDataList = await getViewPoH();
      if (poDataList && poDataList.length > 0) {
        const filteredList = poDataList.filter(
          (item) => item.DocStatus_Name === "อนุมัติ"
        );
        setPoDataList(filteredList);
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY WH_Code ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message);
    }
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของเอกสารอ้างอิง
  const handleChangeDocRefType = (value) => {
    const today = moment();
    const buddhistYear = today.year() + 543;
    const formatted = today.format("DD-MM") + `-${buddhistYear}`;

    setFormMasterList({
      ...recMasterModel(),
      refDocDate: value === "2" ? formatted : null,
      createdDate: getCreateDateTime(),
      createdByName: window.localStorage.getItem("name"),
    });

    setFormDetailList([]);
    setSelectedDiscountValueType("2");
    setTotalPrice(0);
    setReceiptDiscount(0);
    setSubFinal(0);
    setGrandTotal(0);
    setIsVatChecked(false);
    setVatAmount(0);
    setDocRefType(value);
  };

  const calculateItemTotal = (
    itemQty,
    itemPriceUnit,
    itemDiscount,
    itemDisType
  ) => {
    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดเป็นเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดเป็นจำนวนเงิน
    }

    return Math.max(0, itemTotal); // ไม่ให้ itemTotal ติดลบ
  };

  const getModelByNo = async (apDataList) => {
    try {
      // ค้นหาข้อมูลเอกสารที่ตรงกับ Rec_No
      const findMaster = await getDataWithComp("REC_H", "");
      const fromDatabase = findMaster.find((rec) => rec.Rec_No === maxRecNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // กำหนดประเภทเอกสารอ้างอิงตามข้อมูลที่มีอยู่
      if (fromDatabase.Ref_DocID) {
        setDocRefType("1"); // อ้างอิงตามใบสั่งซื้อ
      } else {
        setDocRefType("2"); // รับเฉพาะรายการ
      }

      // ค้นหาข้อมูลผู้ขายด้วย AP_ID
      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === fromDatabase.AP_ID
      );

      if (!fromViewAp) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลผู้ขาย");
      }

      // ค้นหาข้อมูล PO ด้วย Ref_DocID (ถ้ามี)
      if (fromDatabase.Ref_DocID) {
        const formPoMaster = await getByDocId(
          "PO_H",
          fromDatabase.Ref_DocID,
          ""
        );
        setDocStatusPo(formPoMaster[0].Doc_Status);
        setDocStatusReceivePo(formPoMaster[0].Doc_Status_Receive);
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0301_REC_H", "");
      const fromView = findViewMaster.find((data) => data.Rec_No === maxRecNo);
      setStatusName(fromView.RecStatus_Name);
      setStatusColour(fromView.RecStatus_Colour);
      setStatusPaidName(fromView.DocStatusPaid_Name);
      setStatusPaidColour(fromView.DocStatusPaid_Colour);

      // ค้นหาข้อมูลที่ตรงกับ PO_H และ AP_ID ใน apDataList (ถ้ามี)
      let detailResponse = [];
      if (fromDatabase.Ref_DocID) {
        detailResponse = await getDataWithComp(
          "API_0202_PO_D",
          `AND Item_Status = 1 AND Doc_ID = ${fromDatabase.Ref_DocID} ORDER BY Line ASC`
        );
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = Number(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = Number(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = Number(itemSelected.Item_Discount) || 0;
        const ItemDisType = String(itemSelected.Item_DisType || "1");

        const itemTotal = calculateItemTotal(
          itemQty,
          itemPriceUnit,
          itemDiscount,
          ItemDisType
        );

        const detail =
          detailResponse.find(
            (item) => item.Item_Id === itemSelected.Item_Id
          ) || {};
        const itemQtyNow = detail.Item_Qty || 0;
        const itemRecQty = detail.Item_REC_Qty || 0;

        return {
          ...recDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          recId: itemSelected.Rec_ID,
          line: itemSelected?.Line || index + 1,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemRecBalance: Number(itemQtyNow - itemRecQty) || 0,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          Ref_Doc: itemSelected.PO_Number,
          isGift: itemTotal > 0 ? false : true,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Rec_ID
      const fromDetail = await getByRecId(
        "REC_D",
        fromDatabase.Rec_Id,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );

      // ค้นหาข้อมูลของ Detail ของ PO ด้วย Doc_ID (ถ้ามี)
      if (fromDatabase.Ref_DocID) {
        const formPoList = await getByDocId(
          "PO_D",
          fromDatabase.Ref_DocID,
          `AND Item_Status = 1 ORDER BY Line ASC`
        );
        setPoDList(formPoList);
      }

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);
        setFormDetailOldList(newFormDetails);

        setFormMasterList({
          recId: fromDatabase.Rec_Id,
          recNo: fromDatabase.Rec_No,
          recDate: formatThaiDateUi(fromDatabase.Rec_Date || null),
          recDueDate: formatThaiDateUi(fromDatabase.Rec_DueDate || null),
          recStatus: fromDatabase.Rec_Status,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For === "1"
            ? "ซื้อมาเพื่อใช้"
            : fromDatabase.Doc_For === "2"
              ? "ซื้อมาเพื่อขาย"
              : fromDatabase.Doc_For || null,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate
            ? formatThaiDateUi(fromDatabase.Ref_DocDate)
            : null,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          apID: fromDatabase.AP_ID,
          apCode: fromDatabase.AP_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          // แสดงรายชื่อผู้ขาย
          apName: fromViewAp.AP_Name,
          apAdd1: fromViewAp.AP_Add1,
          apAdd2: fromViewAp.AP_Add2,
          apAdd3: fromViewAp.AP_Add3,
          apProvince: fromViewAp.AP_Province,
          apZipcode: fromViewAp.AP_Zipcode,
          apTaxNo: fromViewAp.AP_TaxNo,
          invoice: fromDatabase.Ref_Invoice,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = Number(fromDatabase.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Rec_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);

  const onRowSelectItem = (itemsSelected) => {
    try {
      const selectedArray = Array.isArray(itemsSelected)
        ? itemsSelected
        : [itemsSelected];

      // กรอง item ไม่ให้ซ้ำตาม Item_Id
      const uniqueItems = Array.from(
        new Set(selectedArray.map((item) => item.Item_Id))
      ).map((id) => selectedArray.find((item) => item.Item_Id === id));

      // เริ่มจาก list เดิม
      let updatedList = [...formDetailList];

      uniqueItems.forEach((itemSelected) => {
        const index = updatedList.findIndex(
          (existing) => existing.itemId === itemSelected.Item_Id
        );

        const existingItem =
          updatedList.find((i) => i.itemId === itemSelected.Item_Id) || {};

        const newItem = {
          line: existingItem.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemNameEN:
            itemSelected.Item_Name_EN || existingItem.itemNameEN || "",
          itemQty: formatCurrency(1),
          itemUnit:
            itemSelected.Item_Unit_IN ||
            itemSelected.Item_Unit_ST ||
            existingItem.itemUnit ||
            null,
          itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
          itemDiscount: formatCurrency(0),
          itemDisType: "1",
          itemTotal: 1 * (itemSelected.Item_Cost || 0),
          itemStatus: itemSelected.Item_Status || existingItem.itemStatus || "",
          whId: itemSelected.WH_Id || existingItem.whId || 5,
          whName: itemSelected.WH_Name || existingItem.whName || "คลังสินค้า",
          zoneId: itemSelected.Zone_Id || existingItem.zoneId || null,
          ltId: existingItem.ltId || null,
          dsSeq: existingItem.dsSeq || null,
          Ref_DocID: itemSelected.Doc_ID || existingItem.Ref_DocID || null,
          Ref_Doc: itemSelected.Doc_No || existingItem.Ref_Doc || null,
        };

        if (index !== -1) {
          // ✅ ถ้ามี itemId นี้อยู่แล้ว → แทนที่
          updatedList[index] = newItem;
        } else {
          // ✅ ถ้ายังไม่มี → เพิ่มใหม่
          updatedList.push(newItem);
        }
      });

      setFormDetailList(updatedList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const onRowSelectItemForEdit = (itemSelected, rowIndex) => {
    try {
      setFormDetailList((prevList) => {
        if (!prevList[rowIndex]) {
          console.warn("❌ ไม่พบแถวที่ต้องการแก้ไข:", rowIndex);
          return prevList;
        }

        const selectedItemId = itemSelected.Item_Id;

        const updatedItem = {
          ...prevList[rowIndex],
          itemId: selectedItemId,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemNameEN: itemSelected.Item_Name_EN,
          itemQty: formatCurrency(1),
          itemUnit: itemSelected.Item_Unit_ST,
          itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
          itemDiscount: formatCurrency(0),
          itemDisType: "1",
          itemTotal: 1 * (itemSelected.Item_Cost || 0),
        };

        // ✅ Map รายการใหม่ทั้งหมด
        const updatedList = prevList.map((item, idx) => {
          if (idx === rowIndex) {
            return updatedItem;
          }
          return item;
        });

        // ✅ ลบรายการอื่นที่ซ้ำ (ยกเว้น rowIndex)
        const deduplicatedList = updatedList.filter((item, idx) => {
          const isDuplicate =
            item.itemId === selectedItemId && idx !== rowIndex;
          return !isDuplicate;
        });

        return deduplicatedList;
      });

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };



  const handleRemoveRow = async (index) => {
    try {
      setFormDetailList((prevList) => {
        // ดึงค่าของ dtId ก่อนลบ
        const itemToDelete = prevList[index];

        // ถ้ามี dtId (หมายถึงเป็นข้อมูลที่มีอยู่ในฐานข้อมูล) ให้เก็บไว้ใน state เพื่อลบทีหลัง
        if (itemToDelete?.dtId) {
          setItemsToDelete((prev) => [...prev, itemToDelete.dtId]);
        }

        // กรองรายการที่เหลือ (ลบออกจาก UI เท่านั้น)
        const updatedList = prevList.filter((_, i) => i !== index);

        return updatedList; // คืนค่า updatedList เพื่ออัปเดต UI
      });
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET WAREHOUSE
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const handleWarehouseShow = () => setShowWarehouseModal(true);
  const handleWarehouseClose = () => setShowWarehouseModal(false);
  const onRowSelectWh = async (whSelected) => {
    handleWarehouseClose();

    if (formDetailList && formDetailList.length > 0) {
      for (let index = 0; index < formDetailList.length; index++) {
        await handleChangeDetail(index, "whId", whSelected.WH_Id);
      }
    } else {
      getAlert("FAILED", "กรุณาเลือกสินค้าก่อน");
    }
  };

  // SET PO SHOW (เพิ่มฟังก์ชันที่ขาดหาย)
  const handlePOShow = () => {
    // ฟังก์ชันสำหรับแสดง PO Modal ใน ItemTable
    // อาจจะเป็นการแสดง Modal เพิ่มเติมหรือการจัดการอื่นๆ
    console.log("PO Show function called");
  };

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const newValue = selectedDiscountValueType === value ? null : value;

    setSelectedDiscountValueType(newValue);

    setFormMasterList((prev) => ({
      ...prev,
      discountValueType: newValue !== null ? Number(newValue) : null,
    }));
  };

  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (Number(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = Number(formMasterList?.discountValue || 0);
    let totalPriceValue = Number(totalPrice || 0);
    let discountType = selectedDiscountValueType ?? "1";

    let receiptDiscount = 0;
    if (discountType === "2" && totalPriceValue > 0) {
      receiptDiscount = (totalPriceValue / 100) * discountValue;
    } else if (discountType === "1") {
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal =
      parseCurrency(Number(subFinal)) + parseCurrency(Number(vatAmount));
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  const handleSubmit = async (status) => {
    try {
      setShowConfirmModal(true);
      setIsLoading(true);

      await randomDelay();

      const findMaxRecNo = await getDataWithComp(
        "REC_H",
        "ORDER BY Rec_No DESC"
      );
      const maxRec = getMaxRecNo(findMaxRecNo);
      let newMaxRec = maxRec;

      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return;
      }

      // เปลี่ยนจากการบล็อกเป็นการเตือน
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);

        const result = await Swal.fire({
          title: 'คำเตือน',
          text: 'ไม่พบรายละเอียดสินค้า คุณต้องการบันทึกเอกสารว่างหรือไม่?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#EF6C00',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ใช่, บันทึก',
          cancelButtonText: 'ยกเลิก'
        });

        if (!result.isConfirmed) {
          return;
        }

        setIsLoading(true);
      }

      for (const item of formDetailList) {
        if (item.itemCode || item.itemName) {
          if (
            (item.isGift !== true || item.isGift === undefined) &&
            (!item.itemQty || parseFloat(item.itemQty) === 0)
          ) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากจำนวนสินค้าของ ${item.itemName || "รายการไม่ระบุ"
              } เป็น 0.00 หรือไม่มีค่า`
            );
            return;
          }

          if (
            (item.isGift !== true || item.isGift === undefined) &&
            (!item.itemPriceUnit || parseFloat(item.itemPriceUnit) === 0)
          ) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName || "รายการไม่ระบุ"
              }`
            );
            return;
          }

          if (item.whId && parseInt(item.whId) === 13) {
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า`
            );
            setIsLoading(false);
            return;
          }
        }
      }

      const truncateString = (str, maxLength) =>
        str?.length > maxLength ? str.substring(0, maxLength) : str;

      const validateAndFormatDate = (dateValue) => {
        if (!dateValue) return null;

        try {
          return formatStringDateToDate(dateValue);
        } catch (error) {
          return moment().format("YYYY-MM-DD HH:mm:ss");
        }
      };

      const currentDateTime = getCreateDateTime();
      const formMasterData = {
        rec_no: newMaxRec,
        rec_date:
          validateAndFormatDate(formMasterList.recDate) ||
          moment().format("YYYY-MM-DD HH:mm:ss"),
        rec_due_date:
          validateAndFormatDate(formMasterList.recDueDate) ||
          moment().format("YYYY-MM-DD HH:mm:ss"),
        rec_status: 2,
        doc_status_paid: 0,
        doc_code: 3,
        doc_type: parseInt(formMasterList.docType || 1, 10),
        doc_for: formMasterList.docFor || "รับสินค้า",
        ref_doc_id: formMasterList.refDocID || null,
        ref_doc: formMasterList.refDoc || null,
        ref_doc_date: formMasterList.refDocDate
          ? validateAndFormatDate(formMasterList.refDocDate)
          : null,
        ref_project_id: formMasterList.refProjectID || null,
        ref_project_no: formMasterList.refProjectNo || null,
        comp_id: window.localStorage.getItem("company"),
        transport_type: parseInt(formMasterList.transportType || 1, 10),
        doc_remark1: truncateString(formMasterList.docRemark1 || "", 200),
        doc_remark2: truncateString(formMasterList.docRemark2 || "", 200),
        ap_id: parseInt(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: 0,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseInt(selectedDiscountValueType, 10),
        discount_cash: parseCurrency(receiptDiscount),
        discount_cash_type: formMasterList.discountCashType || 1,
        discount_transport: parseCurrency(0.0),
        discount_transport_type: formMasterList.discountTransportType || 1,
        is_vat: isVatChecked ? 1 : 2,
        doc_seq: truncateString(formatDateTime(new Date()), 20),
        credit_term: parseInt(formMasterList.creditTerm || 0, 10),
        credit_term_1_day: 0,
        credit_term_1_remark: truncateString(
          formMasterList.creditTerm1Remark || "",
          200
        ),
        credit_term_2_remark: truncateString(
          formMasterList.creditTerm2Remark || "",
          200
        ),
        acc_code: "0000",
        emp_name: truncateString(formMasterList.empName || "", 100),
        created_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: "1",
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        invoice: formMasterList.invoice || null,
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-rec-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const validDetails = formDetailList.filter(
          (item) =>
            item.itemCode ||
            item.itemName ||
            (item.itemQty && Number(item.itemQty) !== 0)
        );

        if (validDetails.length > 0) {
          const getRecIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-rec-no`,
            {
              table: "REC_H",
              rec_no: formMasterData.rec_no,
              comp_id: window.localStorage.getItem("company"),
            },
            { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
          );

          if (getRecIdResponse && getRecIdResponse.data.length > 0) {
            const recId = parseInt(getRecIdResponse.data[0].Rec_Id, 10);
            let maxLine = 1;

            if (formMasterList.refDocID && docRefType === "1") {
              const getMaxLine = await getLineByDocId(
                "PO_D",
                formMasterList.refDocID
              );
              maxLine = getMaxLine?.[0]?.Line
                ? parseInt(getMaxLine[0].Line, 10) + 1
                : 1;
            }

            for (const item of validDetails) {
              if (item.itemId) {
                let itemsData = itemDataList.filter(
                  (itemData) => item.itemId === itemData.Item_Id
                );

                let itemQty;
                if (!itemsData || itemsData.length === 0) {
                  itemQty =
                    parseFloat(item.itemQty?.toString().replace(/,/g, "")) || 0;
                } else {
                  let itemData = itemsData[0];
                  let qtyOut = itemData.Item_Qty_Out || 1;
                  itemQty =
                    (parseFloat(item.itemQty?.toString().replace(/,/g, "")) ||
                      0) * qtyOut;
                }

                await manageWhItemData(
                  item.itemId,
                  item.itemCode,
                  item.itemName,
                  item.whId,
                  "IN",
                  itemQty,
                  recId,
                  newMaxRec,
                  formMasterList.refDoc,
                  null
                );
              }

              let formDetailData = {
                rec_id: recId,
                line: maxLine,
                item_id: item.itemId || null,
                item_code:
                  item.itemCode && item.itemCode !== "-"
                    ? item.itemCode.substring(0, 20)
                    : "",
                item_name: item.itemName
                  ? item.itemName.substring(0, 200)
                  : "ไม่ระบุ",
                item_qty: parseCurrency(item.itemQty) || 0,
                item_unit: item.itemUnit || "",
                item_price_unit: parseCurrency(item.itemPriceUnit) || 0,
                item_discount: parseCurrency(item.itemDiscount) || 0,
                item_distype: item.itemDisType === "1" ? 1 : 2,
                item_total: parseCurrency(
                  item.itemDisType === "2"
                    ? parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit) -
                    (parseCurrency(item.itemDiscount) / 100) *
                    (parseCurrency(item.itemQty) *
                      parseCurrency(item.itemPriceUnit))
                    : parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit) -
                    parseCurrency(item.itemDiscount)
                ),
                item_status: 1,
                wh_id: parseInt(item.whId, 10) || 5,
                zone_id: 1,
                lt_id: 1,
                ds_seq: truncateString(formatDateTime(new Date()), 20),
                po_number: item.Ref_Doc || "",
              };

              // อัพเดท PO_D สำหรับการรับสินค้าตามใบสั่งซื้อ
              if (formMasterList.refDocID && docRefType === "1" && item.itemId) {
                try {
                  // แยก refDocID หลายรายการ (กรณีที่มีการรับสินค้าจากหลาย PO)
                  const refDocIds = item.Ref_DocID ? [item.Ref_DocID] :
                    formMasterList.refDocID.toString().split(',').map(id => id.trim());

                  for (const docId of refDocIds) {
                    const poDetailResponse = await getDataWithComp(
                      "API_0202_PO_D",
                      `AND Item_Status = 1 AND Doc_ID = ${docId} AND Item_Id = ${item.itemId}`
                    );

                    if (poDetailResponse && poDetailResponse.length > 0) {
                      const poDetailData = poDetailResponse[0];

                      const currentItemQty = parseCurrency(item.itemQty) || 0;
                      const poItemQty = parseCurrency(poDetailData.Item_Qty) || 0;
                      const currentRecQty = parseCurrency(poDetailData.Item_REC_Qty) || 0;

                      // คำนวณจำนวนที่จะอัพเดท (กรณีหลาย PO ให้แบ่งตามสัดส่วน)
                      const qtyToUpdate = refDocIds.length > 1 ?
                        Math.min(currentItemQty, poItemQty - currentRecQty) :
                        currentItemQty;

                      const newItemRecQty = currentRecQty + qtyToUpdate;
                      const newItemRecBalance = Math.max(0, poItemQty - newItemRecQty);

                      console.debug("PO Update Info:", {
                        docId,
                        itemId: item.itemId,
                        poItemQty,
                        currentRecQty,
                        qtyToUpdate,
                        newItemRecQty,
                        newItemRecBalance
                      });

                      await updateQty(
                        "PO_D",
                        `Item_REC_Qty = ${newItemRecQty}, Item_REC_Balance = ${newItemRecBalance}`,
                        `WHERE Doc_ID = ${docId} AND Item_Id = ${item.itemId} AND Item_Status = 1`
                      );

                      // ตรวจสอบและอัพเดทสถานะ PO_H สำหรับแต่ละ PO
                      const allPoDetails = await getDataWithComp(
                        "API_0202_PO_D",
                        `AND Item_Status = 1 AND Doc_ID = ${docId}`
                      );

                      const isFullyReceived = allPoDetails.every(detail => {
                        const detailQty = parseCurrency(detail.Item_Qty) || 0;
                        const detailRecQty = detail.Item_Id === item.itemId ? newItemRecQty : (parseCurrency(detail.Item_REC_Qty) || 0);
                        return detailRecQty >= detailQty;
                      });

                      if (isFullyReceived) {
                        await updateStatusByNo(
                          "PO_H",
                          "Doc_Status",
                          4,
                          `WHERE Doc_Id = ${docId}`
                        );
                      }
                    }
                  }
                } catch (error) {
                  console.error("Error updating PO_D:", error);
                  // ไม่ throw error เพื่อไม่ให้หยุดการทำงานของการบันทึก REC
                }
              }

              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-rec-d`,
                formDetailData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );


              maxLine++;
            }
          }
        }



        callInitialize();
        getAlert(response.data.status, response.data.message);
      } else {
        getAlert("FAILED", response.data.message || "การบันทึกไม่สำเร็จ");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async (status) => {
    try {
      setIsLoading(true);

      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบผู้ขาย");
        return;
      }

      // เปลี่ยนจากการบล็อกเป็นการเตือน
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);

        const result = await Swal.fire({
          title: 'คำเตือน',
          text: 'ไม่พบรายละเอียดสินค้า คุณต้องการบันทึกเอกสารว่างหรือไม่?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#EF6C00',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ใช่, บันทึก',
          cancelButtonText: 'ยกเลิก'
        });

        if (!result.isConfirmed) {
          return;
        }

        setIsLoading(true);
      }

      for (const item of formDetailList) {
        if (item.itemCode || item.itemName) {
          if (
            (item.isGift !== true || item.isGift === undefined) &&
            (!item.itemPriceUnit || parseFloat(item.itemPriceUnit) <= 0)
          ) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถแก้ไขได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName || "รายการไม่ระบุ"
              }`
            );
            return;
          }

          if (
            (item.isGift !== true || item.isGift === undefined) &&
            (!item.itemQty || parseFloat(item.itemQty) === 0)
          ) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากจำนวนสินค้าของ ${item.itemName || "รายการไม่ระบุ"
              } เป็น 0.00 หรือไม่มีค่า`
            );
            return;
          }
        }
      }

      const formMasterData = {
        rec_no: formMasterList.recNo,
        rec_date: formatStringDateToDate(formMasterList.recDate),
        rec_due_date: formatStringDateToDate(formMasterList.recDueDate) || null,
        rec_status: formMasterList?.recStatus || null,
        doc_status_paid: formMasterList?.docStatusPaid || 0,
        doc_code: formMasterList.docCode || null,
        doc_type: formMasterList.docType || null,
        doc_for: formMasterList.docFor || null,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc || null,
        ref_doc_date: formMasterList.refDocDate
          ? formatStringDateToDate(formMasterList.refDocDate)
          : null,
        ref_project_id: formMasterList.refProjectID || null,
        ref_project_no: formMasterList.refProjectNo || null,
        comp_id: Number(formMasterList.compId) || 3,
        transport_type: formMasterList.transportType || null,
        doc_remark1: formMasterList.docRemark1 || null,
        doc_remark2: formMasterList.docRemark2 || null,
        ap_id: formMasterList.apID || null,
        ap_code: formMasterList.apCode || null,
        action_hold: formMasterList.actionHold || null,
        discount_value_type: formMasterList?.discountValueType || null,
        discount_value: parseCurrency(formMasterList?.discountValue) || 0.0,
        discount_cash: parseCurrency(receiptDiscount) || 0.0,
        discount_cash_type: formMasterList?.discountCashType || null,
        discount_transport: formMasterList?.discountTransport || null,
        discount_transport_type: formMasterList?.discountTransportType || null,
        is_vat: formMasterList?.isVat || null,
        doc_seq: formMasterList?.docSEQ || null,
        credit_term: formMasterList?.creditTerm || null,
        credit_term_1_day: formMasterList?.creditTerm1Day || null,
        credit_term_1_remark: formMasterList?.creditTerm1Remark || null,
        credit_term_2_remark: formMasterList?.creditTerm2Remark || null,
        acc_code: formMasterList?.accCode || null,
        emp_name: formMasterList?.empName || null,
        created_by_name: formMasterList?.createdByName || null,
        created_by_id: formMasterList?.createdById || null,
        update_date: moment()?.format("YYYY-MM-DD HH:mm:ss"),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date:
          formatStringDateToDate(formMasterList.approvedDate) || null,
        approved_by_name: formMasterList?.approvedByName || null,
        approved_by_id: formMasterList?.approvedById || null,
        cancel_date: formatStringDateToDate(formMasterList.cancelDate) || null,
        cancel_by_name: formMasterList?.cancelByName || null,
        cancel_by_id: formMasterList?.cancelById || null,
        approved_memo: formMasterList?.approvedMemo || null,
        printed_status: formMasterList?.printedStatus || "N",
        printed_date:
          formatStringDateToDate(formMasterList.printedDate) || null,
        printed_by: formMasterList?.printedBy || null,
        invoice: formMasterList?.invoice || null,
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-rec-h`,
        formMasterData,
        { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
      );

      if (response.data.status === "OK") {
        // ลบรายการที่เก็บไว้ใน itemsToDelete ก่อน
        if (itemsToDelete.length > 0) {
          for (const dtId of itemsToDelete) {
            // ดึงข้อมูลรายการที่จะลบก่อน เพื่อปรับสต็อก
            const itemToDelete = formDetailOldList.find(item => item.dtId === dtId);

            if (itemToDelete) {
              // ปรับสต็อกออก
              await manageWhItemData(
                itemToDelete.itemId,
                itemToDelete.itemCode,
                itemToDelete.itemName,
                itemToDelete.whId,
                "OUT",
                parseCurrency(itemToDelete.itemQty),
                parseInt(formMasterList.recId, 10),
                formMasterList.recNo,
                formMasterList.refDoc,
                "ลบรายการออกจากใบรับสินค้า"
              );
            }

            // ลบจาก DB
            await deleteData("REC_D", `WHERE DT_Id = ${dtId}`);
          }

          // เคลียร์ itemsToDelete หลังลบเสร็จ
          setItemsToDelete([]);
        }

        const validDetails = formDetailList.filter(
          (item) =>
            item.itemCode ||
            item.itemName ||
            (item.itemQty &&
              item.itemQty !== null &&
              item.itemQty !== undefined)
        );

        const recId = parseInt(formMasterList.recId, 10);

        let existingRecDetails = await getByRecId(
          "REC_D",
          formMasterList.recId,
          "AND Item_Status = 1 ORDER BY Line ASC"
        );

        const deletedItems = existingRecDetails.filter(
          (rec) =>
            rec.Item_Id &&
            !validDetails.some((item) => item.itemId === rec.Item_Id)
        );

        for (const deletedItem of deletedItems) {
          await manageWhItemData(
            deletedItem.Item_Id,
            deletedItem.Item_Code,
            deletedItem.Item_Name,
            deletedItem.WH_ID,
            "OUT",
            parseCurrency(deletedItem.Item_Qty),
            recId,
            formMasterList.recNo,
            formMasterList.refDoc,
            "ลบรายการออกจากใบรับสินค้า"
          );

          await deleteData("REC_D", `WHERE DT_Id = ${deletedItem.DT_Id}`);
        }

        for (const item of validDetails) {
          if (item.itemId) {
            let recDetail = existingRecDetails.filter(
              (rec) => rec.Item_Id === item.itemId
            );

            if (formMasterList.refDocID && docRefType === "1") {
              let poDetail = await getByDocId(
                "PO_D",
                formMasterList.refDocID,
                `AND Item_Status = 1 AND Item_Id = ${item.itemId} ORDER BY Line ASC`
              );

              if (recDetail.length > 0 && poDetail.length > 0) {
                const recItem = recDetail.find(
                  (rec) => rec.Item_Id === item.itemId
                );
                const poItem = poDetail.find(
                  (po) => po.Item_Id === item.itemId
                );

                if (recItem && poItem) {
                  let itemQty = parseCurrency(item.itemQty);
                  let itemRecQty =
                    poItem.Item_REC_Qty - recItem?.Item_Qty + itemQty;
                  let itemRecBalance =
                    (poItem?.Item_REC_Balance || 0) +
                    recItem?.Item_Qty -
                    itemQty;

                  await updateQty(
                    "PO_D",
                    `Item_REC_Qty = ${itemRecQty}, Item_REC_Balance = ${itemRecBalance || 0
                    }`,
                    `WHERE Doc_ID = ${formMasterList.refDocID} AND Item_Id = ${item.itemId} AND Item_Status = 1`
                  );

                  // ตรวจสอบและอัพเดทสถานะ PO_H หากรับสินค้าครบแล้ว
                  const allPoDetails = await getDataWithComp(
                    "API_0202_PO_D",
                    `AND Item_Status = 1 AND Doc_ID = ${formMasterList.refDocID}`
                  );

                  const isFullyReceived = allPoDetails.every(detail => {
                    const detailQty = parseCurrency(detail.Item_Qty) || 0;
                    const detailRecQty = detail.Item_Id === item.itemId ? itemRecQty : (parseCurrency(detail.Item_REC_Qty) || 0);
                    return detailRecQty >= detailQty;
                  });

                  if (isFullyReceived) {
                    await updateStatusByNo(
                      "PO_H",
                      "Doc_Status",
                      4,
                      `WHERE Doc_Id = ${formMasterList.refDocID}`
                    );
                  }
                }
              }
            }

            let oldRecItem = recDetail.find(
              (rec) => rec.Item_Id === item.itemId
            );
            if (oldRecItem) {
              let oldQty = parseCurrency(oldRecItem.Item_Qty) || 0;
              let newQty = parseCurrency(item.itemQty) || 0;

              if (oldQty !== newQty) {
                await manageWhItemData(
                  item.itemId,
                  item.itemCode,
                  item.itemName,
                  oldRecItem.WH_ID,
                  "OUT",
                  oldQty,
                  recId,
                  formMasterList.recNo,
                  formMasterList.refDoc,
                  "แก้ไขใบรับสินค้า"
                );
                await manageWhItemData(
                  item.itemId,
                  item.itemCode,
                  item.itemName,
                  item.whId,
                  "IN",
                  newQty,
                  recId,
                  formMasterList.recNo,
                  formMasterList.refDoc,
                  "แก้ไขใบรับสินค้า"
                );
              }
            }
          }

          if (item.dtId) {
            await deleteData("REC_D", `WHERE DT_Id = ${item.dtId}`);
          }

          let lineNumber = 1;
          if (item.itemId && formMasterList.refDocID && docRefType === "1") {
            const poDetail = await getByDocId(
              "PO_D",
              formMasterList.refDocID,
              `AND Item_Id = ${item.itemId} ORDER BY Line ASC`
            );
            lineNumber = poDetail[0]?.Line || 1;
          }

          const formDetailData = {
            rec_id: recId,
            line: lineNumber,
            item_id: item.itemId || null,
            item_code:
              item.itemCode && item.itemCode !== "-"
                ? item.itemCode.substring(0, 20)
                : "",
            item_name: item.itemName
              ? item.itemName.substring(0, 200)
              : "ไม่ระบุ",
            item_qty: parseCurrency(item.itemQty) || 0,
            item_unit: item.itemUnit || "",
            item_price_unit: parseCurrency(item.itemPriceUnit) || 0,
            item_discount: parseCurrency(item.itemDiscount) || 0,
            item_distype: item.itemDisType === "1" ? 1 : 2,
            item_total: parseCurrency(
              item.itemDisType === "2"
                ? parseCurrency(item.itemQty) *
                parseCurrency(item.itemPriceUnit) -
                (parseCurrency(item.itemDiscount) / 100) *
                (parseCurrency(item.itemQty) *
                  parseCurrency(item.itemPriceUnit))
                : parseCurrency(item.itemQty) *
                parseCurrency(item.itemPriceUnit) -
                parseCurrency(item.itemDiscount)
            ),
            item_rec_qty: parseCurrency("0.00"),
            item_rec_balance: parseCurrency(item.itemQty) || 0,
            item_status: item.itemStatus || 1,
            wh_id: parseInt(item.whId, 10) || 5,
            zone_id: parseInt("1", 10),
            lt_id: parseInt("1", 10),
            ds_seq: formatDateTime(new Date()).substring(0, 20),
            po_number: item.Ref_Doc || "",
          };

          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-rec-d`,
            formDetailData,
            { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
          );
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      setIsLoading(true);
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseInt(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถแก้ไขได้เนื่องจากไม่พบจำนวนของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseInt(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถแก้ไขได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        // if (!item.whId || parseInt(item.whId) === 13) {
        //     getAlert("FAILED", `ไม่สามารถแก้ไขได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`);
        //     return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        // }
      }

      // ********** ยกเลิกใบรับสินค้า ต้องย้อน PO_D ด้วย (เดี๋ยวมาทำต่อ)
      // DELETE PO_D เฉพาะรายการที่ค้างเก็บประวัติทั้งหมด (Where DocId & Item_Status = 0)
      await deleteData(
        "PO_D",
        `WHERE Doc_ID = ${formMasterList.refDocID} AND Item_Status = 0`
      );

      const poMasterList = await getByDocId(
        "PO_H",
        formMasterList.refDocID,
        ``
      );
      const poDetailList = await getByDocId(
        "PO_D",
        poMasterList[0].Doc_Id,
        `ORDER BY Line ASC`
      );
      const prDetailList = await getByDocId(
        "PR_D",
        poMasterList[0].Ref_DocID,
        `ORDER BY Line ASC`
      );

      for (const item of formDetailList) {
        let prDetail = prDetailList.find((pr) => pr.Item_Id === item.itemId);
        let poDetail = poDetailList.find((po) => po.Item_Id === item.itemId);

        // อัพเดท
        await updateQty(
          "PO_H",
          `Doc_Status_Receive = ${parseInt("1", 10)}`,
          `WHERE Doc_Id = ${formMasterList.refDocID}`
        );

        // DELETE PO_D เฉพาะรายการที่ค้างเก็บประวัติทั้งหมด (Where DocId & Item_Status = 0)
        await deleteData(
          "PO_D",
          `WHERE Doc_ID = ${formMasterList.refDocID}
                     AND Item_Status = 0`
        );

        // อัพเดทจำนวนที่คำนวณใหม่ (โดยการ Where ด้วย DT_Id)
        await updateQty(
          "PO_D",
          `Item_Qty = ${parseFloat(prDetail.Item_Qty.replace(/,/g, "")) || 0}, 
                     Item_Total = ${prDetail.Item_Total}, 
                     Item_REC_Qty = ${parseInt("0", 10)}, 
                     Item_REC_Balance = ${parseFloat(prDetail.Item_Qty.replace(/,/g, "")) || 0
          }`,
          `WHERE DT_Id = ${poDetail.DT_Id} AND Item_Status = 1`
        );

        // #####################################
        // WH_ITEM_Onhand => Update (Loop Item) => Search WH_ITEM_Onhand Where Item,WH,Comp
        // WH_ITEM_STC => Insert (Loop Item) => Search WH_ITEM_STC Where Item,WH,Comp ORDER BY DATE
        // #####################################
        await manageWhItemData(
          item.itemId, // Item ไอดีของสิ่งนั้นๆ
          item.itemCode, // Item โค้ดของสิ่งนั้นๆ
          item.itemName, // ชื่อ Item นั้นๆ
          item.whId, // WarehouseID ของไอเทม
          "OUT", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
          parseFloat(item.itemQty.replace(/,/g, "")) || 0, // ค่าจำนวนที่กรอกจากหน้าจอ
          formMasterList.refDocID, // ไอดีเอกสาร
          formMasterList.recNo, // เลขเอกสาร
          "ยกเลิก ".concat(formMasterList.recNo), // เลขเอกสารอ้างอิง
          null // หมายเหตุ
        );
      }

      const formMasterData = {
        rec_no: formMasterList.recNo,
        rec_status: parseInt("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-rec-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      setIsLoading(false);
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // ฟังก์ชันจัดการการเปลี่ยนแปลงของข้อมูลทั่วไป
  const handleChangeDetail = (index, field, value) => {
    // // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    // if (!/^\d*\.?\d*$/.test(value)) {
    //   return;
    // }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    const itemQty = parseFloat(parseCurrency(updatedList[index].itemQty)) || 0;
    const itemPriceUnit =
      parseFloat(parseCurrency(updatedList[index].itemPriceUnit)) || 0;
    const itemDiscount =
      parseFloat(parseCurrency(updatedList[index].itemDiscount)) || 0;
    const itemDisType = String(updatedList[index].itemDisType || "1");

    updatedList[index].itemTotal = calculateItemTotal(
      itemQty,
      itemPriceUnit,
      itemDiscount,
      itemDisType
    );
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    if (typeof updatedList[index][field] !== "string") {
      updatedList[index][field] = String(updatedList[index][field] || "");
    }
    updatedList[index][field] = updatedList[index][field].replace(/,/g, "");
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  const handleConfirmtModal = () => {
    let shouldShowModal = false;

    formDetailList.forEach((item) => {
      // แปลงค่าของ item.itemQty และ item.itemRecBalance เป็นตัวเลข
      const itemQty = Number(item.itemQty);
      const itemRecBalance = Number(item.itemRecBalance);
    });

    if (shouldShowModal) {
      if (mode === "U") {
        // ไม่ให้โหมดแก้ไข เลือกปิด PO ได้
        handleUpdate(parseInt("2", 10));
      } else {
        handleUpdate(parseInt("2", 10));
      }
    } else {
      if (mode === "U") {
        handleUpdate(parseInt("3", 10));
      } else {
        handleSubmit(parseInt("3", 10));
      }
    }
  };

  const handleConfirmtModal2 = () => {
    let shouldShowModal = false;

    // ตรวจสอบว่ามีรายการสินค้าในฟอร์มหรือไม่
    if (!formDetailList || formDetailList.length === 0) {
      getAlert("FAILED", "ไม่สามารถปิดงาน PO ได้ เนื่องจากไม่มีรายการสินค้า");
      return;
    }

    // ตรวจสอบว่า `refDoc` มีค่าไหม (ต้องมีเอกสารอ้างอิง)
    if (!formMasterList.refDoc) {
      getAlert("FAILED", "ไม่สามารถปิดงาน PO ได้ เนื่องจากไม่มีเอกสารอ้างอิง");
      return;
    }

    // ตรวจสอบจำนวนสินค้า (ตัวอย่างการตรวจสอบ)
    formDetailList.forEach((item) => {
      const itemQty = Number(item.itemQty);
      const itemRecBalance = Number(item.itemRecBalance);

      // เงื่อนไขเพิ่มเติมถ้าจำเป็น
      if (itemQty !== itemRecBalance) {
        shouldShowModal = true;
      }
    });

    // ถ้ามีรายการที่ต้องตรวจสอบเพิ่มเติมให้เปิด Modal ยืนยัน
    if (shouldShowModal) {
      if (mode === "U") {
        // แก้ไขเอกสารแทนการสร้างใหม่
        handleUpdate(2); // สถานะ 2 = ค้างรับ
      } else {
        handleSubmit(2);
      }
    } else {
      // ถ้าทุกอย่างโอเค ให้ปิดงาน PO
      if (mode === "U") {
        handleUpdate(3); // สถานะ 3 = ปิดงาน PO
      } else {
        handleSubmit(3);
      }
    }
  };

  const updateFormDetailList = (index, field, value) => {
    const numericValue = parseCurrency(value) || 0;
    const updatedList = [...formDetailList];
    updatedList[index][field] = numericValue;

    // ดึงค่าจากรายการสินค้า
    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    // คำนวณราคารวมเบื้องต้น
    let itemTotal = itemQty * itemPriceUnit;

    // ตรวจสอบประเภทส่วนลด
    if (itemDisType === "2" && itemDiscount > 0) {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ส่วนลดเป็นเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ส่วนลดเป็นจำนวนเงิน
    }

    // ป้องกันราคาติดลบ และกำหนดให้มีทศนิยม 2 ตำแหน่ง
    updatedList[index].itemTotal = Math.max(0, itemTotal).toFixed(2);

    setFormDetailList(updatedList);
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;

    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    console.log("value, name");
    let newValue;

    if (!value) {
      newValue = null;
    } else if (value && value instanceof moment) {
      const year = value.year();
      if (year < 1753 || year > 9999) {
        newValue = moment().format("YYYY-MM-DD");
      } else {
        newValue = value.format("YYYY-MM-DD");
      }
    } else {
      newValue = value;
    }

    setFormMasterList((prev) => ({
      ...prev,
      [name]: newValue ? formatDateOnChange(newValue) : null,
    }));
  };

  // SET PO
  const [showPoModal, setShowPoModal] = useState(false);
  const handlePoShow = () => setShowPoModal(true);
  const handlePoClose = () => setShowPoModal(false);
  const [selectedPoList, setSelectedPoList] = useState([]);

  const onRowSelectPo = async (poSelectedList) => {
    try {
      if (!poSelectedList || poSelectedList.length === 0) {
        getAlert("FAILED", "กรุณาเลือกอย่างน้อย 1 รายการ");
        return;
      }


      // เก็บค่าที่เคยกรอกไว้ก่อนหน้า
      const previousFormMasterList = { ...formMasterList };
      const previousFormDetailList = [...formDetailList];

      // เคลียร์รายละเอียดสินค้า

      // ดึงข้อมูล PO_H ทั้งหมด
      const allPoH = await getDataWithComp(
        "API_0201_PO_H",
        "ORDER BY Doc_No DESC"
      );

      // ตรวจสอบข้อมูลผู้ขาย (AP_ID)
      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === poSelectedList[0].AP_ID
      );
      if (!fromViewAp) throw new Error("ไม่พบข้อมูลผู้ขาย");

      // กรอง PO_H ที่ตรงกับ PO ที่เลือก
      const selectedPoH = allPoH.filter((po) =>
        poSelectedList.some((sel) => sel.Doc_No === po.Doc_No)
      );
      if (selectedPoH.length === 0)
        throw new Error("ไม่พบข้อมูลใบสั่งซื้อที่เลือก");

      // ดึงข้อมูล PO_D ทั้งหมด
      // const allPoD = await getDataWithComp(
      //   "API_0202_PO_D",
      //   "AND Item_Status = 1 ORDER BY Line ASC"
      // );

      // ดึงข้อมูล PO_D ที่เชื่อมโยงกับ PO ที่เลือก
      const docIds = poSelectedList.map(po => po.Doc_ID).join(',');
      const poDetails = await getDataWithComp(
        "API_0202_PO_D",
        `AND Item_Status = 1 AND Doc_ID IN (${docIds}) ORDER BY Line ASC`
      );
      // เช็คว่ามี item_REC_QTy หรือไม่ ถ้ามีให้ใช้ Item_REC_Balance แทน Item_Qty
      poDetails.forEach(item => {
        if (item.Item_REC_Qty && item.Item_REC_Qty > 0) {
          item.Item_Qty = item.Item_REC_Balance || 0;
        } else {
          item.Item_Qty = item.Item_Qty || 0;
        }
      });

      // เพิ่ม Ref_DocID และ Ref_Doc ให้กับรายการ
      poDetails.forEach(item => {
        const matchedPo = poSelectedList.find(po => po.Doc_ID === item.Doc_ID);
        if (matchedPo) {
          item.Ref_DocID = matchedPo.Doc_ID;
          item.Ref_Doc = matchedPo.Doc_No;
        }
      });

      const refDocText =
        poSelectedList.length > 1
          ? `${poSelectedList[0].Doc_No} ...`
          : poSelectedList[0]?.Doc_No || "";

      const formMasterData = {
        ...previousFormMasterList,
        refDocID: previousFormMasterList.refDocID || poSelectedList[0].Doc_ID,
        refDoc: refDocText,
        refDocDate:
          previousFormMasterList.refDocDate ||
          formatThaiDateUi(poSelectedList[0]?.Doc_Date),
        docDate: previousFormMasterList.docDate || formatThaiDateUi(moment()),
        docDueDate:
          previousFormMasterList.docDueDate || formatThaiDateUi(moment()),
        docRemark1:
          previousFormMasterList.docRemark1 || poSelectedList[0]?.Doc_Remark1,
        docRemark2:
          previousFormMasterList.docRemark2 || poSelectedList[0]?.Doc_Remark2,
        docType: previousFormMasterList.docType || poSelectedList[0]?.Doc_Type,
        docFor: previousFormMasterList.docFor ||
          (poSelectedList[0]?.Doc_For === "1"
            ? "ซื้อมาเพื่อใช้"
            : poSelectedList[0]?.Doc_For === "2"
              ? "ซื้อมาเพื่อขาย"
              : poSelectedList[0]?.Doc_For),
        transportType:
          previousFormMasterList.transportType ||
          poSelectedList[0]?.Transport_Type,
        discountValue:
          previousFormMasterList.discountValue ||
          poSelectedList[0]?.Discount_Value,
        creditTerm: previousFormMasterList.creditTerm || fromViewAp?.AP_Credit,
        apID: previousFormMasterList.apID || fromViewAp?.AP_Id,
        apCode: previousFormMasterList.apCode || fromViewAp?.AP_Code,
        apName: previousFormMasterList.apName || fromViewAp?.AP_Name,
        apAdd1: previousFormMasterList.apAdd1 || fromViewAp?.AP_Add1,
        apAdd2: previousFormMasterList.apAdd2 || fromViewAp?.AP_Add2,
        apAdd3: previousFormMasterList.apAdd3 || fromViewAp?.AP_Add3,
        apProvince:
          previousFormMasterList.apProvince || fromViewAp?.AP_Province,
        apZipcode: previousFormMasterList.apZipcode || fromViewAp?.AP_Zipcode,
        apTaxNo: previousFormMasterList.apTaxNo || fromViewAp?.AP_TaxNo,
        createdByName:
          previousFormMasterList.createdByName ||
          window.localStorage.getItem("name"),
        createdDate: previousFormMasterList.createdDate || getCreateDateTime(),
        updateDate: previousFormMasterList.updateDate,
        updateByName: previousFormMasterList.updateByName,
        discountValueType:
          previousFormMasterList.discountValueType ||
          poSelectedList[0]?.Discount_Value_Type,
      };

      console.debug("formMasterData po", formMasterData, poSelectedList);
      setFormMasterList(formMasterData);

      // ✅ เพิ่มเฉพาะรายการใหม่เข้า `formDetailList` โดยไม่ลบข้อมูลเดิม
      console.debug("poDetails", poDetails);
      const newFormDetails = poDetails.map((item, index) => ({
        ...recDetailModel(index + 1),
        line: item?.Line,
        itemId: item?.Item_Id,
        itemCode: item?.Item_Code,
        itemName: item?.Item_Name,
        itemQty: formatCurrency(Number(item.Item_Qty) || 0),
        itemUnit: item?.Item_Unit,
        itemPriceUnit: formatCurrency(Number(item?.Item_Price_Unit)) || 0,
        itemDiscount: Number(item?.Item_Discount) || 0,
        itemDisType: String(item?.Item_DisType || "1"),
        itemTotal: calculateItemTotal(
          Number(item.Item_Qty) || 0,
          Number(item?.Item_Price_Unit) || 0,
          Number(item?.Item_Discount) || 0,
          String(item?.Item_DisType || "1")
        ),
        itemGroup: item?.Item_Group,
        itemStatus: item?.Item_Status,
        whId:
          previousFormDetailList.find((d) => d.itemId === item.Item_Id)?.whId ||
          5,
        zoneId: item?.Zone_ID,
        ltId: item?.LT_ID,
        dsSeq: item?.DS_SEQ,
        Ref_DocID: item?.Ref_DocID,
        Ref_Doc: item?.Ref_Doc,
        isGift: item.Item_Total > 0 ? false : true,
      }));

      const updatedFormDetails = [
        ...previousFormDetailList,
        ...newFormDetails.filter(
          (newItem) =>
            !previousFormDetailList.some(
              (prevItem) =>
                prevItem.itemId === newItem.itemId &&
                prevItem.Ref_DocID === newItem.Ref_DocID
            )
        ),
      ];

      setFormDetailList(updatedFormDetails);

      setIsVatChecked(formMasterData.isVat !== 1);

      if (formMasterData?.discountValueType) {
        setSelectedDiscountValueType(
          formMasterData.discountValueType.toString()
        );
      }

      handlePoClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
        creditTerm: apSelected.AP_Credit,
      });

      if (Number(apSelected.AP_Vat) === 1) {
        setIsVatChecked(true);
      }

      handleApClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const onRowSelectItem02 = () => {
    try {
      const emptyItem = {
        line: null,
        itemId: null,
        itemCode: null,
        itemName: null,
        itemQty: formatCurrency(0),
        itemUnit: "",
        itemPriceUnit: formatCurrency(0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: 0,
        itemStatus: "Y",
        whId: null,
        whName: "",
        zoneId: null,
        ltId: null,
        dsSeq: null,
        Ref_Doc: null,
        isSpecRow: false,
      };

      setFormDetailList((prev) => [...prev, emptyItem]);

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };
  useEffect(() => {
    // เรียกใช้ getViewItem  เพิ่มSetitemDatalist อีกครั้งเมื่อ showItemModal
    if (showItemModal) {
      getViewItem().then((data) => {
        setItemDataList(data);
      }).catch((error) => {
        getAlert("FAILED", error.message || "ไม่สามารถดึงข้อมูลสินค้าได้");
      });
    }
  }, [showItemModal]);

  return (
    <>
      <Breadcrumbs
        page={maxRecNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherStatusName={statusPaidName}
        otherStatusColour={statusPaidColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/product-receipt" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => getReport("rec", formMasterList.recNo)}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="recDate"
                value={formMasterList.recDate || null}
                onChange={(date) => handleChangeDateMaster(date, "recDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ผู้ขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.apCode || "") +
                    " " +
                    (formMasterList.apName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                {/* แสดงปุ่มค้นหาผู้ขายเฉพาะเมื่อเลือก "รับเฉพาะรายการ" */}
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleApShow}
                  hidden={docRefType === "2" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ApModal
              showApModal={showApModal}
              handleApClose={handleApClose}
              apDataList={apDataList}
              onRowSelectAp={onRowSelectAp}
            />
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label className="">เอกสารอ้างอิง</label>
              <select
                name="docRefType"
                value={docRefType}
                className="form-select form-control input-spacing"
                onChange={(e) => handleChangeDocRefType(e.target.value)}
                disabled={mode === "U"}
              >
                <option value="1">รับตามใบสั่งซื้อ</option>
                <option value="2">รับเฉพาะรายการ</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.apAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={
                    mode === "U" ? true : docRefType === "1" ? true : false
                  }
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handlePoShow}
                  hidden={docRefType === "1" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <PoModal
                showPoModal={showPoModal}
                handlePoClose={handlePoClose}
                poDataList={poDataList}
                onRowSelectPo={(selectedPoList) =>
                  onRowSelectPo(selectedPoList)
                }
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apAdd2 || "") +
                  " " +
                  (formMasterList.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสารอ้างอิง</label>
              {docRefType === "2" && mode !== "U" ? (
                <Datetime
                  className="input-spacing-input-date"
                  name="refDocDate"
                  value={formMasterList.refDocDate || null}
                  onChange={(date) =>
                    handleChangeDateMaster(date, "refDocDate")
                  }
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  inputProps={{ readOnly: true, disabled: mode === "U" }}
                />
              ) : (
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDocDate"
                  value={formMasterList.refDocDate || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
              )}
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apAdd2 || "") +
                  " " +
                  (formMasterList.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        {/* ส่วนอื่นๆ ของ Form ยังคงเหมือนเดิม */}
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={
                  docRefType === "1" ? true : mode === "U" ? true : false
                }
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apProvince || "") +
                  " " +
                  (formMasterList.apZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              {/* <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMaster}
                // disabled={
                //   docRefType === "1" ? true : mode === "U" ? true : false
                // }
                className="form-select form-control input-spacing"
              >
                <option value="1">ซื้อมาเพื่อใช้</option>
                <option value="2">ซื้อมาเพื่อขาย</option>
              </select> */}
              <input
                type="text"
                className="form-control input-spacing"
                name="docFor"
                value={formMasterList.docFor || ""}
                onChange={handleChangeMaster}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.apTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            {/* ว่างไว้สำหรับการขยายในอนาคต */}
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>Due Date</label>
              <Datetime
                className="input-spacing-input-date"
                name="recDueDate"
                value={formMasterList.recDueDate || null}
                onChange={(date) => handleChangeDateMaster(date, "recDueDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: false }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>Invoice</label>
              <input
                name="invoice"
                onChange={handleChangeMaster}
                type="text"
                className="form-control input-spacing"
                value={formMasterList.invoice || ""}
              />
            </div>
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* ว่างไว้สำหรับการขยายในอนาคต */}
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                disabled={false}
                className="form-select form-control input-spacing"
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* ว่างไว้สำหรับการขยายในอนาคต */}
          </div>
        </div>

        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <textarea
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
                maxLength={255}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <textarea
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
                maxLength={255}
              />
            </div>
          </div>
        </div>

        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            setFormDetailList={setFormDetailList}
            handleChangeDetail={handleChangeDetail}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            onRowSelectItem02={onRowSelectItem02}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            showWarehouseModal={showWarehouseModal}
            handleWarehouseClose={handleWarehouseClose}
            handleWarehouseShow={handleWarehouseShow}
            handlePOShow={handlePOShow}
            onRowSelectWh={onRowSelectWh}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            poDataList={poDataList}
            disabledRec={formMasterList.recStatus === 13}
            disabled={mode === "U" ? true : false}
            onRowSelectItemForEdit={onRowSelectItemForEdit}
            docRefType={docRefType}
          />

          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={false}
            docRefType={docRefType} // ส่งประเภทเอกสารอ้างอิงไปยัง Summary
          />
        </div>
      </div>

      <br />
      <FormAction
        onSubmit={handleConfirmtModal}
        onUpdate={handleConfirmtModal}
        onCancel={handleCancel}
        mode={mode}
        disabled={formMasterList.recStatus !== 2 ? true : false}
        footer={true}
        maxDocNo={maxRecNo}
      />
    </>
  );
}

export default Form;
